import { Controller } from '@hotwired/stimulus';
/*
 * Description
 * -------
 *
 * Clicks on link when it is in the viewport.
 *
 * Must be used on link element.
 * Should be used only once in the document.
 *
 * Values
 * -------
 *
 * rootMargin - (optional) - margin around the viewport
 *
 * Usage
 * -------
 *
 * <a href="#" data-controller="infinite-scroll"></a>
 */
export class InfiniteScroll extends Controller {
    static values = {
        rootMargin: { type: String, default: '2500px 0px 2500px 0px' },
    };
    connect() {
        this.observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                this.element.click();
            }
        }, {
            rootMargin: this.rootMarginValue,
        });
        this.observer.observe(this.element);
    }
    disconnect() {
        this.observer?.unobserve(this.element);
    }
}
